import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { OwnerService } from "../../../services/billing-letter/owner.service";
import { OptionsBilling } from "../../enums/billing-letter/OptionsBilling";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { CompaniesService } from "../../../services/companies.service";
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import { ConsultantService } from "../../../services/consultant.service";
import { ConsultantSearch } from "../../../models/ConsultantSearch.model";
import { UserService } from "../../../services/user.service";

@Injectable()
export class RefundFiltersFactory extends FiltersFactory {
    constructor(private localStorage: LocalStorage,
        private ownerService: OwnerService,
        private commonHelper: CommonHelper,
        private optionsBilling: OptionsBilling,
        private companiesService: CompaniesService,
        private dropdownItemFactory: DropdownItemFactory,
        private dropdownSettingFactory: DropdownSettingsFactory,
        private consultantService: ConsultantService,
        private userService: UserService) { super() }

    async build(filters, localStorageFilterKey = 'refunds') {

        // filters.companies.list = this.dropdownItemFactory.build({ source: await this.companiesService.listAllWithBillings() });
        // filters.owners.list = this.dropdownItemFactory.build({ source: await this.ownerService.getAll() });
        
        // if(filters.consultant){
        //     let consultantSearch = new ConsultantSearch();
        //     consultantSearch.onlyActives = false;
        //     consultantSearch.limit = 9999999;
        //     filters.consultant.list = this.dropdownItemFactory.build({source: await this.consultantService.searchConsultants(consultantSearch)});
        //     filters.consultant.options = this.dropdownSettingFactory.build({text:"Consultores"});
        // }

        // if(filters.responsible){
        //     filters.responsible.list = this.dropdownItemFactory.build({source:await this.userService.getAllUsersAsResponsibles()});
        //     filters.responsible.options = this.dropdownSettingFactory.build({text:"Gestores"});
        // }

        // filters.divisions.list = this.optionsBilling.division;
        // filters.status.list = this.optionsBilling.status;
           

        // filters.owners.options = this.dropdownSettingFactory.build({ text: 'Requisitantes' });
        // filters.companies.options = this.dropdownSettingFactory.build({ text: 'Clientes' });
        // filters.divisions.options = this.dropdownSettingFactory.build({ text: 'Divisões' });
        // filters.status.options = this.dropdownSettingFactory.build({ text: 'Status' });

        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/refunds/filters.factory.ts